import React, {ReactElement} from "react";
import {ReactComponent as BottlesImage} from "components/Icons/bottles.svg";
import {ReactComponent as AperitifsImage} from "components/Icons/aperitifs.svg";
import { PrimaryButton } from "components/UIComponents/PrimaryButton";
import { FormattedMessage } from "react-intl";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import { menuEditorActions, menuEditorSelectors } from "../editorSlice";
import { labelEditorActions } from "features/label-editor/labelEditorSlice";

export interface EmptyPreviewProps {

}

export function EmptyPreview(props: EmptyPreviewProps): ReactElement | null {
    const dispatch = useAppDispatch();
    const openWinePicker = () => dispatch(menuEditorActions.setWinePickerActive(true));
    const openAperitifPicker = () => dispatch(menuEditorActions.setAperitifPickerActive(true));
    const document = useAppSelector(menuEditorSelectors.document);
    const addLabelItem = () => dispatch(labelEditorActions.addNewLabelItem());
    return (
        <div className="h-full flex flex-col justify-center items-center gap-5">
          {document?.type==='label'
          ? <>
            <PrimaryButton onClick={addLabelItem}>
              <FormattedMessage id="editor.label.emptyMsg" />
            </PrimaryButton>
          </>
          : document?.type==='aperitif'
          ? <>
            <AperitifsImage />

            <PrimaryButton onClick={openAperitifPicker}>
              <FormattedMessage id="editor.aperitif.emptyMsg" />
            </PrimaryButton>
          </>
          : <>
            <BottlesImage />

            <PrimaryButton onClick={openWinePicker}>
              <FormattedMessage id="editor.empty.msg" />
            </PrimaryButton>
          </>
          }
        </div>
    );
}